import {ProductionCategoryDao} from '../../dao';
import {ProductionCategoryModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateProductionCategory(
    userData: Record<string, string>,
    productionCategoryId: number,
    update: Record<string, any>
) {
    try {
        const result = await ProductionCategoryDao.updateProductionCategory(userData.userToken, productionCategoryId, update);

        const resultParsed = ProductionCategoryModel.parseProductionCategory(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
